import { OrganizationAPI, InvitationAPI, AccountAPI } from "../api";
import { InvitationProvider, AccountProvider } from ".";

const accountProvider = {
  fetchAccountsByOrganizationId: (
    organizationId: string,
    download?: boolean,
  ) => {
    if (!organizationId) {
      return Promise.resolve([]);
    }
    return AccountAPI.activeByOrganizationId(
      organizationId,
      download ? { format: "xlsx" } : {},
    );
  },
  fetchAccountsByOrganizationAndAccountType: (
    organizationId: string,
    accountTypeId: string,
    download?: boolean,
  ) => {
    if (!organizationId) {
      return Promise.resolve([]);
    }
    return AccountAPI.byOrganizationAndAccountType(
      organizationId,
      accountTypeId,
      download ? { format: "xlsx" } : {},
    );
  },
  fetchByAccountId: (accountId: string) => {
    if (!accountId) {
      return Promise.resolve([]);
    }
    const result = AccountAPI.get(accountId);
    return result;
  },
  fetchAccountOrganization: (organizationId: string) => {
    if (!organizationId) {
      return Promise.resolve([]);
    }
    return OrganizationAPI.get(organizationId);
  },
  listAccountsIsMemberOf: (userId: string) => {
    if (!userId) return Promise.resolve([]);
    return AccountAPI.listAccountsByMember(userId);
  },

  getAuditEvents: (accountId: string) => {
    if (!accountId) return Promise.resolve([]);
    return AccountAPI.auditEventsBySubjectId(accountId);
  },

  // currently cannot unassign a role from an 'Account'
} as AccountProvider;

const invitationProvider = {
  fetch: (organizationId: string) => {
    if (!organizationId) {
      return Promise.resolve([]);
    }
    return InvitationAPI.accountsByOrganization(organizationId);
  },
  delete: (id: string) => {
    return InvitationAPI.delete(id).then((result) => {
      return result;
    });
  },
  assignRole: (roleId: string, invitationId: string) => {
    return InvitationAPI.assignRole(roleId, invitationId);
  },
  unassignRole: (roleId: string, invitationId: string) => {
    return InvitationAPI.unassignRole(roleId, invitationId);
  },
} as InvitationProvider;

export { accountProvider, invitationProvider };
